import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPersonWalking = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.47412 3.554C8.47412 4.25019 8.75068 4.91787 9.24297 5.41016C9.73525 5.90244 10.4029 6.179 11.0991 6.179C11.7953 6.179 12.463 5.90244 12.9553 5.41016C13.4476 4.91787 13.7241 4.25019 13.7241 3.554C13.7241 2.85781 13.4476 2.19013 12.9553 1.69785C12.463 1.20556 11.7953 0.929001 11.0991 0.929001C10.4029 0.929001 9.73525 1.20556 9.24297 1.69785C8.75068 2.19013 8.47412 2.85781 8.47412 3.554V3.554Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.1511 11.8C17.8138 11.8009 17.4807 11.7255 17.1766 11.5796C16.8725 11.4336 16.6054 11.2208 16.3951 10.957C15.6719 10.0477 14.7524 9.31388 13.7053 8.81045C12.6583 8.30702 11.5109 8.04704 10.3491 8.05C8.75831 8.05159 7.23311 8.68424 6.10823 9.80911C4.98336 10.934 4.35071 12.4592 4.34912 14.05C4.34912 14.4478 4.50716 14.8294 4.78846 15.1107C5.06977 15.392 5.4513 15.55 5.84912 15.55C6.24695 15.55 6.62848 15.392 6.90978 15.1107C7.19109 14.8294 7.34912 14.4478 7.34912 14.05C7.35119 13.386 7.57307 12.7413 7.98011 12.2167C8.38715 11.6921 8.95645 11.317 9.59912 11.15V11.65C9.60182 14.8807 8.64542 18.0394 6.85112 20.726C6.74186 20.8901 6.666 21.0742 6.62788 21.2677C6.58975 21.4612 6.59011 21.6602 6.62892 21.8536C6.70732 22.244 6.9376 22.5873 7.26912 22.808C7.60064 23.0287 8.00624 23.1086 8.39669 23.0302C8.78714 22.9518 9.13046 22.7215 9.35112 22.39C10.2999 20.9659 11.0562 19.4225 11.6001 17.8C13.1635 18.7862 14.3392 20.2812 14.9291 22.033C14.9861 22.2262 15.0815 22.4059 15.2094 22.5614C15.3374 22.7169 15.4954 22.8451 15.6739 22.9383C15.8525 23.0314 16.048 23.0877 16.2488 23.1037C16.4496 23.1196 16.6515 23.095 16.8426 23.0313C17.0336 22.9675 17.2099 22.8659 17.3608 22.7326C17.5118 22.5993 17.6343 22.4369 17.7212 22.2551C17.808 22.0734 17.8574 21.8761 17.8663 21.6749C17.8752 21.4736 17.8435 21.2727 17.7731 21.084C16.8566 18.3546 14.9098 16.0913 12.3481 14.777C12.5168 13.7432 12.6014 12.6975 12.6011 11.65V11.62C13.1623 11.9226 13.6566 12.3355 14.0541 12.834C14.5447 13.4503 15.1683 13.9477 15.8784 14.2889C16.5884 14.63 17.3664 14.8061 18.1541 14.804C18.5519 14.804 18.9335 14.646 19.2148 14.3647C19.4961 14.0834 19.6541 13.7018 19.6541 13.304C19.6541 12.9062 19.4961 12.5246 19.2148 12.2433C18.9335 11.962 18.5519 11.804 18.1541 11.804L18.1511 11.8Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPersonWalking.displayName = 'SvgPersonWalking';
export default SvgPersonWalking;
